var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('v-container',[_c('h2',{staticClass:"mt-4 mx-3 google-sans-regular"},[_vm._v("Ödev Ekle")]),_c('add-homework-form',{staticClass:"mx-3"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }